import { render, staticRenderFns } from "./Ai.vue?vue&type=template&id=aac83486&scoped=true"
import script from "./Ai.vue?vue&type=script&lang=js"
export * from "./Ai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac83486",
  null
  
)

export default component.exports